import React from 'react';
import ScienceExhibition2023 from 'views/ScienceExhibition2023'

const SchoolProgrampage = () => {
  return <ScienceExhibition2023 />;
};

export default SchoolProgrampage;